import { render, staticRenderFns } from "./ChangeAddress.vue?vue&type=template&id=32b5a532&scoped=true"
import script from "./ChangeAddress.vue?vue&type=script&lang=ts"
export * from "./ChangeAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5a532",
  null
  
)

export default component.exports